module.exports = __webpack_public_path__ + "release.mp3?3724d066a937a4b802fc5084d6f3118b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/release.mp3
// module id = 30
// module chunks = 0